export default __webpack_public_path__ + "static/media/bg11.a4cc293b.jpg";